import React from 'react'
import UserForm from './userForm'

const AddStudent = () => {
  return (
    <div>
      <UserForm />
    </div>
  )
}

export default AddStudent
